export default __webpack_public_path__ + "static/media/chevrons-left.fa0a079d.svg";